import { render, staticRenderFns } from "./legalAdviceSign.vue?vue&type=template&id=7334f385&scoped=true&"
import script from "./legalAdviceSign.vue?vue&type=script&lang=js&"
export * from "./legalAdviceSign.vue?vue&type=script&lang=js&"
import style0 from "./legalAdviceSign.vue?vue&type=style&index=0&id=7334f385&prod&lang=less&scoped=true&"
import style1 from "./legalAdviceSign.vue?vue&type=style&index=1&id=7334f385&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334f385",
  null
  
)

export default component.exports